export const DEFAULT_PATIENT_HAS_TUBE = {
  '無': false,
  '鼻胃管': false,
  '尿管': false,
  '氣切': false,
  '廔管': false,
  '引流管': false,
  '其他': '',
};